module.exports = __webpack_public_path__ + "static/media/w-Whole numbers.dc1ae392.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/w-Whole numbers.png
// module id = 191
// module chunks = 0